import { Component } from "@angular/core";
import { I18nService } from "../../services/i18n.service";
import { Observable } from "rxjs";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
	currentLanguage: Observable<string>;

	constructor(private i18nService: I18nService) {
		this.i18nService = i18nService;
	}

	/**
	 * Change language function
	 * @param language : language string
	 */
	changeLanguage(language: string): void {
		this.i18nService.switchLanguage(language);
	}

	ngOnInit() {
		this.currentLanguage = this.i18nService.currentLanguage.asObservable();
	}
}
